import React from 'react';

const ErrorPage = () => {
  return(
    <div>
      Dang. Ok, it's a 404. Can't find that page you were looking for right at this moment, but maybe if you try again later?
    </div>
  )
}

export default ErrorPage;